import React, { useState, useEffect } from 'react'
import { EMPTY_ARRAY, EMPTY_OBJECT } from '../constants/globalConstants'
import PublicRoutes from './PublicRoutes'

function RoutesComponent() {
    const [login, setLogin] = useState(EMPTY_OBJECT)
    useEffect(() => {
        const isLogin = localStorage.getItem('userDetails') ? localStorage.getItem('userDetails') : '{}'
        const userLoggedIn = JSON.parse(isLogin)
        if (userLoggedIn !== null || userLoggedIn !== undefined) {
            setLogin(userLoggedIn)
        } else {
            setLogin(EMPTY_OBJECT)
        }
    }, [EMPTY_ARRAY])

    if (Object.values(login) < 1) {
        return <PublicRoutes />
    }
}

export default RoutesComponent
